import * as React from "react";
import UnmappedAccountsIndicator from "./UnmappedAccountsIndicator";
import UnmappedAccountsPanel from "./UnmappedAccountsPanel";

interface UnmappedAccountsState {
  panelOpen: boolean;
}

export class UnmappedAccounts extends React.Component<
  {},
  UnmappedAccountsState
> {
  constructor(props: {}) {
    super(props);

    this.state = {
      panelOpen: false
    };
  }

  public handleClose = () => {
    this.setState({ panelOpen: false });
  };

  public handleOpen = () => {
    this.setState({ panelOpen: true });
  };

  public render() {
    return this.state.panelOpen ? (
      <UnmappedAccountsPanel closePanel={this.handleClose} />
    ) : (
      <UnmappedAccountsIndicator openPanel={this.handleOpen} />
    );
  }
}

export default UnmappedAccounts;



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/unmappedAccounts/UnmappedAccounts.tsx